{
  "schema_version": 1,
  "task_id": "L5-USER-DECISION-CENTER-001",
  "status": "decision-center-ready",
  "generated_at": "2026-07-31T03:12:16+08:00",
  "authority_boundary": {
    "observational_only": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "task_completion_authority": false
  },
  "summary": {
    "decision_count": 3,
    "requires_user_decision_count": 3,
    "can_execute_now_count": 0,
    "safe_autonomous_action_count": 1,
    "blocked_external_action_count": 3
  },
  "safe_autonomous_actions": [
    {
      "id": "continue-local-product-polish",
      "can_start_without_user_input": true,
      "allowed_effect": "read_only_ui_docs_evidence_polish",
      "description_zh": "继续优化本地桌面 AIOS Home、官网 Living Blueprint、只读状态、文档、Evidence 与校验器。",
      "description_en": "Continue polishing local desktop AIOS Home, the official Living Blueprint, read-only status, docs, Evidence and checkers."
    }
  ],
  "decisions": [
    {
      "id": "L5-REAL-CLOUD-SYNC-USER-DECISION-001",
      "state": "risk",
      "category": "cloud-sync",
      "title_zh": "真实云同步是否启动",
      "title_en": "Whether to activate real cloud sync",
      "requires_user_decision": true,
      "can_execute_now": false,
      "current_allowed_effect": "explain_prepare_task_spec_only",
      "reason_zh": "需要用户选择云服务商、账号、OAuth/Secret 路径、费用、数据范围、冲突策略和回滚责任。",
      "reason_en": "Requires user choices for provider, account, OAuth/Secret path, cost, data scope, conflict policy and rollback responsibility.",
      "user_choices_required": [
        {
          "id": "provider",
          "label_zh": "云服务商",
          "label_en": "Cloud provider",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "account_owner",
          "label_zh": "账号与责任人",
          "label_en": "Account and owner",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "oauth_secret_path",
          "label_zh": "OAuth / Secret 注入路径",
          "label_en": "OAuth / Secret injection path",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "cost_budget",
          "label_zh": "费用预算与停止线",
          "label_en": "Cost budget and stop line",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "data_scope",
          "label_zh": "同步数据范围",
          "label_en": "Data sync scope",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "conflict_policy",
          "label_zh": "冲突与无覆盖策略",
          "label_en": "Conflict and no-clobber policy",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "rollback_owner",
          "label_zh": "回滚责任人与验收方式",
          "label_en": "Rollback owner and acceptance",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        }
      ],
      "forbidden_until_complete": [
        "connect_account",
        "start_oauth",
        "store_secret",
        "cloud_read",
        "cloud_write",
        "runtime_activation",
        "external_write",
        "paid_action"
      ],
      "activation_path": [
        "user_choice",
        "activation_task_spec",
        "secret_path_confirmation",
        "read_only_preflight",
        "small_scope_canary",
        "rollback_drill",
        "independent_reviewer",
        "explicit_user_go"
      ]
    },
    {
      "id": "L5-ECOSYSTEM-PUBLISHING-ACTIVATION-USER-DECISION-001",
      "state": "risk",
      "category": "ecosystem-publishing",
      "title_zh": "生态发布是否启动",
      "title_en": "Whether to activate ecosystem publishing",
      "requires_user_decision": true,
      "can_execute_now": false,
      "current_allowed_effect": "explain_prepare_task_spec_only",
      "reason_zh": "需要用户选择发布目标、许可/归属、账号、费用、撤回路径、对外分发责任和支持边界。",
      "reason_en": "Requires user choices for publication target, license/attribution, account, cost, unpublish path, external-distribution responsibility and support boundary.",
      "user_choices_required": [
        {
          "id": "publication_target",
          "label_zh": "发布目标",
          "label_en": "Publication target",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "license_attribution",
          "label_zh": "许可与署名归属",
          "label_en": "License and attribution",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "publishing_account",
          "label_zh": "发布账号",
          "label_en": "Publishing account",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "cost_policy",
          "label_zh": "费用与配额策略",
          "label_en": "Cost and quota policy",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "unpublish_path",
          "label_zh": "撤回与下架路径",
          "label_en": "Unpublish path",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "support_boundary",
          "label_zh": "对外支持责任边界",
          "label_en": "External support boundary",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        }
      ],
      "forbidden_until_complete": [
        "cloud_write",
        "publish_plugin",
        "publish_skill",
        "submit_marketplace",
        "external_distribution",
        "external_write",
        "external_message",
        "runtime_activation",
        "store_secret",
        "paid_action"
      ],
      "activation_path": [
        "user_choice",
        "publishing_task_spec",
        "license_review",
        "security_review",
        "distribution_dry_run",
        "rollback_plan",
        "independent_reviewer",
        "explicit_user_go"
      ]
    },
    {
      "id": "L5-EXTERNAL-DISTRIBUTION-USER-DECISION-001",
      "state": "risk",
      "category": "external-distribution",
      "title_zh": "生产级外部分发是否启动",
      "title_en": "Whether to activate production external distribution",
      "requires_user_decision": true,
      "can_execute_now": false,
      "current_allowed_effect": "explain_prepare_task_spec_only",
      "reason_zh": "需要用户确认法律/账号、分发策略、费用、支持责任、回滚、事故预案和对外沟通边界。",
      "reason_en": "Requires user confirmation for legal/account choices, distribution policy, cost, support responsibility, rollback, incident plan and external-communication boundary.",
      "user_choices_required": [
        {
          "id": "legal_account",
          "label_zh": "法律主体与账号",
          "label_en": "Legal entity and account",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "distribution_policy",
          "label_zh": "分发策略",
          "label_en": "Distribution policy",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "cost_support",
          "label_zh": "费用与支持责任",
          "label_en": "Cost and support responsibility",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "rollback_incident_plan",
          "label_zh": "回滚与事故预案",
          "label_en": "Rollback and incident plan",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        },
        {
          "id": "external_communication",
          "label_zh": "对外沟通边界",
          "label_en": "External communication boundary",
          "required": true,
          "user_provided": false,
          "stores_secret": false
        }
      ],
      "forbidden_until_complete": [
        "cloud_write",
        "production_distribution",
        "external_write",
        "external_message",
        "deployment",
        "store_secret",
        "paid_action",
        "runtime_activation"
      ],
      "activation_path": [
        "user_choice",
        "distribution_task_spec",
        "legal_and_license_review",
        "cost_review",
        "support_and_incident_review",
        "rollback_drill",
        "independent_reviewer",
        "explicit_user_go"
      ]
    }
  ],
  "handoff_integration": {
    "final_handoff_pack": "config/l5-final-handoff-pack.json",
    "project_status": "config/aios-project-status.json",
    "must_match_next_tasks": true,
    "must_keep_all_external_actions_blocked": true
  }
}
